import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useCountry } from '../../../components/CountrySelector';
import { useCart } from '../useCart';
import {
  LegacyUpdateCartMutationVariables,
  LegacyUpdateCartMutation,
  LEGACY_UPDATE_CART_MUTATION,
  LegacyUpdateCartMutationAttributes,
  LegacyCartUpdateAction
} from './useLegacyUpdateCartMutation.rest';

export const useLegacyUpdateCartMutation = () => {
  const countryCode = useCountry().country.alpha2Code;
  const { cart } = useCart();

  const [mutate, { data, loading, error }] = useMutation<
    LegacyUpdateCartMutation,
    LegacyUpdateCartMutationVariables
  >(LEGACY_UPDATE_CART_MUTATION, { fetchPolicy: 'no-cache' });

  const updateLegacyCart = useCallback(
    async (actionType: LegacyCartUpdateAction, attributes: LegacyUpdateCartMutationAttributes) => {
      const cartId = attributes.id || cart.id;

      if (!cartId) return Promise.reject('updateLegacyCart: cart not found');

      return await mutate({
        variables: {
          id: cartId,
          countryCode,
          target: cart.attributes.version,
          input: {
            data: {
              action_type: actionType,
              attributes,
              id: cartId,
              type: 'carts'
            }
          }
        }
      });
    },
    [cart.attributes.version, cart.id, countryCode, mutate]
  );

  return [updateLegacyCart, { data, loading, error }] as const;
};
